// @ts-nocheck
import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
import * as Types from "../../../__generated__/schema.graphql.types";

const defaultOptions = {} as const;
export type InAppNotificationsSubscriptionVariables = Types.Exact<{
  [key: string]: never;
}>;

export type InAppNotificationsSubscription = {
  __typename?: "subscription_root";
  inAppNotification: Array<{
    __typename?: "InAppNotification";
    id: string;
    userMedspaId: string;
    message: string;
    created: string;
  }>;
};

export type CloseInAppNotificationMutationVariables = Types.Exact<{
  id: Types.Scalars["bigint"]["input"];
}>;

export type CloseInAppNotificationMutation = {
  __typename?: "mutation_root";
  closeInAppNotification?: {
    __typename?: "InAppNotification";
    id: string;
  } | null;
};

export const InAppNotificationsDocument = gql`
  subscription InAppNotifications {
    inAppNotification(where: { readAt: { _isNull: true } }) {
      id
      userMedspaId
      message
      created
    }
  }
`;

/**
 * __useInAppNotificationsSubscription__
 *
 * To run a query within a React component, call `useInAppNotificationsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useInAppNotificationsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInAppNotificationsSubscription({
 *   variables: {
 *   },
 * });
 */
export function useInAppNotificationsSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    InAppNotificationsSubscription,
    InAppNotificationsSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    InAppNotificationsSubscription,
    InAppNotificationsSubscriptionVariables
  >(InAppNotificationsDocument, options);
}
export type InAppNotificationsSubscriptionHookResult = ReturnType<
  typeof useInAppNotificationsSubscription
>;
export type InAppNotificationsSubscriptionResult =
  Apollo.SubscriptionResult<InAppNotificationsSubscription>;
export const CloseInAppNotificationDocument = gql`
  mutation CloseInAppNotification($id: bigint!) {
    closeInAppNotification: updateInAppNotificationByPk(
      pkColumns: { id: $id }
      _set: { readAt: "now()" }
    ) {
      id
    }
  }
`;
export type CloseInAppNotificationMutationFn = Apollo.MutationFunction<
  CloseInAppNotificationMutation,
  CloseInAppNotificationMutationVariables
>;

/**
 * __useCloseInAppNotificationMutation__
 *
 * To run a mutation, you first call `useCloseInAppNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseInAppNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeInAppNotificationMutation, { data, loading, error }] = useCloseInAppNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCloseInAppNotificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CloseInAppNotificationMutation,
    CloseInAppNotificationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CloseInAppNotificationMutation,
    CloseInAppNotificationMutationVariables
  >(CloseInAppNotificationDocument, options);
}
export type CloseInAppNotificationMutationHookResult = ReturnType<
  typeof useCloseInAppNotificationMutation
>;
export type CloseInAppNotificationMutationResult =
  Apollo.MutationResult<CloseInAppNotificationMutation>;
export type CloseInAppNotificationMutationOptions = Apollo.BaseMutationOptions<
  CloseInAppNotificationMutation,
  CloseInAppNotificationMutationVariables
>;
